





































































































































































































































import Vue from "vue";
import CandidateDetailCard from "@/components/recruiter/jobs/post_job/ai_generated/CandidateDetailCard.vue";
import { Swipeable } from "vue-swipy";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import AiJobDescriptionModal from "@/components/recruiter/jobs/post_job/ai_generated/AiJobDescriptionModal.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
  JOB_GENERATION_FROM_PROMPT,
  JOB_GENERATION_MATCHING_CANDIDATES,
  JOB_GENERATION_PROMPT_RESPONSE,
  JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
  MACTHING_CANDIDATE_SHORTLISTED_AND_REJECTED,
  POKE_CANDIDATE
} from "@/store/modules/recruiter/constants";
import {
  MatchingCandidatesStatus,
  SearchedCandidate
} from "@/store/modules/recruiter/interfaces";
import { ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import ViewCandidateProfileDialog from "@/views/recruiter/candidates/ViewCandidateProfileDialog.vue";
import { sort_and_filter_candidates } from "@/utils/global";
import StatusFiltersOnSmScreensVue from "./StatusFiltersOnSmScreens.vue";

export default Vue.extend({
  name: "AiGenerativeCandidateView",
  components: {
    CandidateDetailCard,
    GoBackHeader,
    Swipeable,
    AiJobDescriptionModal,
    ViewCandidateProfileDialog,
    StatusFiltersOnSmScreensVue
  },
  data() {
    return {
      loading: false,
      rejected: [] as SearchedCandidate[],
      accepted: [] as SearchedCandidate[],
      candidate_detail: [] as SearchedCandidate[],
      view_job_detail: false,
      description: "",
      job_title: "",
      show_candidate: false,
      selected_candidate: {} as SearchedCandidate,
      close_button_loading: false,
      filter: null as string | null
    };
  },
  watch: {
    "$vuetify.breakpoint.smAndDown"(isSmallScreen) {
      if (isSmallScreen) {
        this.filter = MatchingCandidatesStatus.UNSELECTED;
      } else {
        this.filter = null;
      }
    }
  },
  computed: {
    ...mapGetters("recruiter", {
      job_generated_prompt: JOB_GENERATION_FROM_PROMPT,
      get_generated_job: JOB_GENERATION_PROMPT_RESPONSE,
      matching_candidate: JOB_GENERATION_MATCHING_CANDIDATES,
      get_rejected_candidates: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
      get_accepted_candidates: JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES
    }),
    MatchingCandidatesStatus() {
      return MatchingCandidatesStatus;
    }
  },
  mounted() {
    this.filter = this.$vuetify.breakpoint.smAndDown
      ? MatchingCandidatesStatus.UNSELECTED
      : null;
  },
  async created() {
    this.loading = true;
    const acceptedIds = new Set(
      this.get_accepted_candidates.map(
        (item: SearchedCandidate) => item.candidate_id
      )
    );
    const rejectedIds = new Set(
      this.get_rejected_candidates.map(
        (item: SearchedCandidate) => item.candidate_id
      )
    );
    if (this.matching_candidate.length) {
      this.loading = false;

      const filteredCandidates = this.matching_candidate.filter(
        (item: SearchedCandidate) =>
          !acceptedIds.has(item.candidate_id) &&
          !rejectedIds.has(item.candidate_id)
      );
      this.candidate_detail = filteredCandidates;
      this.candidate_detail = sort_and_filter_candidates(this.candidate_detail);
      this.candidate_detail.reverse();

      this.rejected = this.get_rejected_candidates;
      this.accepted = this.get_accepted_candidates;
    } else {
      this.loading = false;
      await this.$router.push({ name: "ai-generated-job-posting" });
    }
  },
  methods: {
    ...mapMutations("recruiter", {
      set_accepted_candidate: JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
      set_rejected_candidate: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
      set_candidate_data: JOB_GENERATION_MATCHING_CANDIDATES
    }),
    ...mapActions("recruiter", {
      set_shortlisted_and_rejected_candidate:
        MACTHING_CANDIDATE_SHORTLISTED_AND_REJECTED,
      poke_candidate: POKE_CANDIDATE
    }),
    ...mapMutations({
      root_notification: ROOT_NOTIFICATION
    }),
    async on_swipe_left(index: number) {
      this.close_button_loading = true;
      const removedCandidate = this.candidate_detail.splice(index, 1)[0]; // Explicitly specify the type for removedCandidate
      if (removedCandidate) {
        const data = {
          candidate_id: removedCandidate.candidate_id,
          job_id: removedCandidate.job_id,
          status: MatchingCandidatesStatus.REJECTED
        };
        const response = await this.set_shortlisted_and_rejected_candidate({
          data: [data]
        });
        this.close_button_loading = false;
        if (response) {
          this.rejected.push(removedCandidate);
          // this.set_candidate_data(data);
          this.set_rejected_candidate(this.rejected); // Remove the card from candidate_detail and push it to rejected
        }
      } // Remove the card from candidate_detail and push it to rejected
      this.close_button_loading = false;
      // if (this.candidate_detail.length === 0) {
      //   this.proceed_to_next();
      // }
    },
    async on_swipe_right(index: number) {
      this.close_button_loading = true;
      const acceptedCandidate = this.candidate_detail.splice(index, 1)[0]; // Explicitly specify the type for acceptedCandidate
      if (acceptedCandidate) {
        this.accepted.push(acceptedCandidate);
        const data = {
          candidate_id: acceptedCandidate.candidate_id,
          job_id: acceptedCandidate.job_id,
          status: MatchingCandidatesStatus.SHORTLISTED
        };
        if (acceptedCandidate.candidate_id && acceptedCandidate.job_id) {
          const response = await this.set_shortlisted_and_rejected_candidate({
            data: [data]
          });
          this.close_button_loading = false;
          if (response) {
            // this.set_candidate_data(data);
            this.set_accepted_candidate(this.accepted);
            // const payload: PokeCandidatePayload = {
            //   candidate_id: acceptedCandidate.candidate_id,
            //   job_id: acceptedCandidate?.job_id,
            //   type: "interview_invite",
            //   whatsapp: true,
            //   send_email: false
            // };
            // await this.poke_candidate(payload);
          }
        }
      }
      this.close_button_loading = false;
    },
    view_job_details() {
      if (this.get_generated_job) {
        this.job_title = this.get_generated_job.job_title;
        this.description = this.get_generated_job.job_description;
        this.view_job_detail = true;
      }
      this.view_job_detail = true;
    },
    async proceed_to_next() {
      this.set_candidate_data(this.candidate_detail);
      await this.$router.push({ name: "ai-generated-all-candidates" });
    },
    view_candidate(search_candidate: SearchedCandidate) {
      const job = search_candidate.job_id;
      const user = search_candidate.candidate_id;
      const upload = search_candidate.upload_response_id;
      if (!job || !user || !upload) return;
      sessionStorage.setItem("job", job.toString());
      sessionStorage.setItem("user", user.toString());
      sessionStorage.setItem("upload", upload.toString());
      this.$router.push("/recruiter/candidates/profile");
    },
    async cancel_state(candidate: SearchedCandidate, status: string) {
      this.close_button_loading = true;
      const payload = {
        candidate_id: candidate.candidate_id,
        job_id: candidate.job_id,
        status: "REMOVE"
      };
      const response = await this.set_shortlisted_and_rejected_candidate({
        data: [payload]
      });
      if (response && candidate) {
        this.candidate_detail.push(candidate);
        this.close_button_loading = false;
        if (status === "accepted") {
          this.accepted = this.accepted.filter(
            (item: SearchedCandidate) =>
              item.candidate_id !== candidate.candidate_id
          );
          this.set_accepted_candidate(this.accepted);
          await this.poke_candidate({
            candidate_id: candidate.candidate_id,
            job_id: candidate.job_id,
            type: "cancel_invite",
            whatsapp: false
          });
        } else {
          this.rejected = this.rejected.filter(
            (item: SearchedCandidate) =>
              item.candidate_id !== candidate.candidate_id
          );
          this.set_rejected_candidate(this.rejected);
        }
        candidate.matching_candidate_status =
          MatchingCandidatesStatus.UNSELECTED;
      }
      this.close_button_loading = false;
    },
    on_change_filter(filter: string) {
      this.filter = filter;
    }
  }
});
